import React from "react";
import Contact from "../../components/contact/contact";

type DataProps = {
  // children: any;
};

const Index: React.FC<DataProps> = () => {
  return (
    <div id="contact" className="p-5 pt-10">
      <div className="grid grid-cols-7 pb-10">
        <hr className="col-span-1 content-center mt-10 border-gray-400"></hr>
        <div className="md:pl-3 col-span-6 col-start-2 text-4xl ">
          <div className="text-4xl">
            Contact{" "}
            <small className="pl-1 -mt-2 md:-mt-8 block sm:inline text-xs">
              Get in touch
            </small>
          </div>
        </div>
      </div>
      <div className="md:p-10">
        <Contact />
      </div>
    </div>
  );
};

export default Index;
